// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xzrZ9","toggle":"styles_toggle__3q5DY","preview":"styles_preview__4797l"};